import { Component } from '@angular/core';
import { LoaderService } from '../../core/services/loader.service';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { CommonModule } from '@angular/common';
import { NzIconModule } from 'ng-zorro-antd/icon';

@Component({
    selector: 'app-loader',
    imports: [NzSpinModule, CommonModule, NzIconModule],
    templateUrl: './loader.component.html',
    styleUrl: './loader.component.scss'
})
export class LoaderComponent {
  isLoading: boolean = false;

  constructor(public loaderService: LoaderService) {}

  ngOnInit() {
    this.loaderService.isLoading.subscribe({
      next: (res) => {
        this.isLoading = res;
      },
      error: () => {},
    });
  }
}
